<template>
   <div>
    <el-select
style="width: 100%;"
:value="selectShop"
filterable
remote
:placeholder="$t('pages_deduct_coupon_rule_components_scopeofuse_category_448')"
:remote-method="remoteMethod"
@change="onChange"
          >
          <el-option
            v-for="i in categories"
            :value="i.id"
            :key="i.id"
            :label="i.name"
          >
          </el-option>
        </el-select>
   </div>
</template>

<script>
import i18n from '../../../../locales/index'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ScopeCategory',
  components: {},
  data () {
    return {
      selectShop: '',
      searchValue: ''
    }
  },
  computed: {
    ...mapGetters('category', ['categories', 'meta', 'loading']),
  },
  created () {
    this.index()
  },
  methods: {
    ...mapActions('category', [
      'index',
      'changeQuery'
    ]),
    ...mapMutations('category', ['changeQuery']),

    remoteMethod (query) {
      if (query !== '') {
        this.searchValue = query
        this.changeQuery({ 'q[name_eq]': this.searchValue })
        this.index()
      }
    },
    onChange (value) {
      this.selectShop = value
      const category = this.categories.find(item => item.id === value)
      this.$emit('category', {
        name: category.name,
        value: category.id,
      })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
